module.exports = __webpack_public_path__ + "img/001-pdf.b98acd97.svg";